export default __webpack_public_path__ + "locales/lo-LA/Settings.json?hash=b18ab50a5c4e0f08af776d5a7ac97933";